<template>
  <div>
    <el-card>
      <!-- 页面标题，卡片头 -->
      <div slot="header" class="clearfix">
        <span>水肥监控</span>
        <el-radio-group v-model="park" size="small" style="float: right">
          <el-radio-button
            v-for="park in parks"
            :label="park.id"
            :key="park.id"
          >
            {{ park.name }}
          </el-radio-button>
        </el-radio-group>
      </div>
      <div>
        <div class="flow">
          <div class="data">
            <div class="route1">
              <div>
                <h6>实时流量：2</h6>
                <h6>累计流量：100</h6>
              </div>
              <div>
                <el-switch
                  v-model="switchValue"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                />
              </div>
            </div>
            <div class="left">
              <div v-for="(i, index) in 3" :key="index">
                <div>
                  <el-switch
                    style="margin-left: 20px"
                    v-model="switchValue"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                  />
                </div>
                <div>
                  <h6>实时流量：2</h6>
                  <h6>累计流量：100</h6>
                </div>
              </div>
            </div>
            <div class="right">
              <div
                v-for="(item, index) in routeData"
                :key="index"
                style="display: flex; margin-bottom: 29px"
              >
                <div>
                  <h6>实时流量：2</h6>
                  <h6>累计流量：100</h6>
                </div>
                <div>
                  <el-switch
                    style="margin-left: 26px"
                    v-model="switchValue"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                  />
                </div>
                <div>
                  <el-tag v-if="item.landName!==''" type="info" style="margin-left:48px">
                  <span style="font-size:16px">{{item.landName}}</span>
                  </el-tag>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { parkSearch } from '@/api/park.js'
import {
  getDevicesByParkId,
  getIrrigateRelationsByDeviceId,
} from '@/api/equip.js'
import { getLandInPark } from '@/api/land2.js'
export default {
  name: 'Fertilizer',
  data() {
    return {
      /**
       * 当前园区Id
       */
      park: undefined,
      /**
       * 园区选项
       */
      parks: [],
      switchValue: false,
      /**
       * 遍历线路
       */
      routeData: [],
      /**
       * 设备ID
       */
      equipId: undefined,
    }
  },
  watch: {
    /**
     * 监测当前园区，如果发生变化，则刷新地块列表
     */
    park: function (parkId) {
      this.routeData=[]
      getDevicesByParkId(parkId).then((r) => {
        this.equipId = r.data.find((item) => item.type === 'irrigate').id
        getIrrigateRelationsByDeviceId(this.equipId).then((r) => {
          for (let i = 1; i < 13; i++) {
                let obj = {
                  label: i,
                  landName:''
                }
              this.routeData.push(obj)
          }
          r.data.forEach(a => {
            this.routeData.forEach(b=>{
              if(a.route===b.label){
                b.landName=a.landName
              }
            })
          });
          console.log(this.routeData)
        })
      })
    },
  },
  created() {
    // 初始化园区列表，把列表中首个园区设置为当前园区
    parkSearch({
      enterpriseId: this.$store.getters.currentEnterprise.id,
    }).then((resp) => {
      this.parks = resp.data.list
      this.park = this.parks[0].id
    })
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>

<style scoped>
h6 {
  margin: 0;
  display: block;
}
.flow {
  width: 100%;
  height: 1000px;
  background-image: url('./flowChart.jpeg');
  background-size: 100% auto;
  position: relative;
  z-index: 1;
}
.data {
  z-index: 2;
  font-size: 20px;
}
.route1 {
  position: absolute;
  top: 78px;
  left: 115px;
  display: flex;
}
.route1 div:nth-child(2) {
  margin-left: 62px;
}
.left {
  display: flex;
  position: absolute;
  top: 155px;
  left: 320px;
}
.left div:nth-child(1) {
  margin: 0 38px 33px 0;
}
.left div:nth-child(2) {
  margin: 0 38px 33px 0;
}

.right {
  position: absolute;
  top: 34px;
  left: 1003px;
}
/* .right div{
  margin-bottom: 15px;
} */
</style>



// WEBPACK FOOTER //
// src/components/monitor/fertilizer/Index.vue